import React from "react";
import { isObject, isEmpty, get, isNumber, isString } from "lodash";
import colors from "../colors";
import helper from "utils/helper";
// eslint-disable-next-line
// @ts-ignore:next-line
const reqSvgs = require.context("./svgs", true, /\.svg$/);
export const allSvgs = reqSvgs.keys().reduce((images: any, path: string) => {
  const key = path.substring(path.lastIndexOf("/") + 1, path.lastIndexOf("."));

  images[key] = reqSvgs(path).default;
  // if (isObject(images[key])) images[key].name = key;
  return images;
}, {});
export interface IconProps {
  name?: string;
  style?: object;
  size?: number;
  color?: string;
  [key: string]: any;
}

export const Icons = ({
  name = "",
  size = 24,
  color = "",
  style,
  width,
  height,
  className,
  ...props
}: IconProps) => {
  if (!name) return null;

  const Comp = allSvgs[name];
  if (!Comp) return null;
  if (!isNumber(size)) size = 24;
  width = width ?? size ?? 24;
  height = height ?? size ?? 24;
  return (
    <div className={className} style={{ width, height }}>
      <Comp
        {...props}
        style={{
          // transition: 'all .3s cubic-bezier(.645,.045,.355,1)',
          ...style,
        }}
        color={color}
        width={width}
        height={height}
      />
    </div>
  );
};
export default Icons;
